
export const STEP_DESCRIPTIONS = {
  APPROVER_1: 'Approver 1',
  APPROVER_2: 'Approver 2',
  PROJECT_MANAGER: 'Project Manager',
  LINE_MANAGER: 'Line Manager',
};


export const COUNTRY_VALUE={
    INDIA:'IN058'
}